module.exports = __webpack_public_path__ + "img/038.ef580ed6.png";